import { render, staticRenderFns } from "./FormatSetReferencesTreeSelector.vue?vue&type=template&id=642bf85e&scoped=true&"
import script from "./FormatSetReferencesTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSetReferencesTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSetReferencesTreeSelector.vue?vue&type=style&index=0&id=642bf85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bf85e",
  null
  
)

export default component.exports